import { createSelector } from "reselect";
import { checkSubstitutionsExists, getSubstitutions } from "@/api/materials";

const prefix = "material/substitution";

const SET_NOTICE = `${prefix}/SET_NOTICE`;
const SET_TREE = `${prefix}/SET_TREE`;
const FETCH_START = `${prefix}/FETCH_START`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;

export const setTree = (tree) => ({ type: SET_TREE, payload: tree });
export const setNoticeMaterialId = (id) => ({ type: SET_NOTICE, payload: id });

const fetchStart = (oldMaterialId) => ({ type: FETCH_START, payload: oldMaterialId });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, payload: err, error: true });

const isMaterialNumber = (searchTerm) => {
  return /[R]?[0-9][0-9-]+/.test(searchTerm);
};

export function checkForSubstitutions(searchTerm) {
  return async (dispatch) => {
    try {
      const possibleMaterialId = searchTerm.trim();

      if (isMaterialNumber(possibleMaterialId) && (await checkSubstitutionsExists(possibleMaterialId))) {
        dispatch(setNoticeMaterialId(possibleMaterialId));
      } else {
        dispatch(setNoticeMaterialId(null));
        dispatch(setTree(null));
      }
    } catch (err) {
      console.error(err);
    }
  };
}

export function fetchSubstitutions(oldMaterialId) {
  return async (dispatch) => {
    dispatch(fetchStart(oldMaterialId));

    try {
      const subst = await getSubstitutions(oldMaterialId);
      dispatch(fetchSuccess(subst));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

const baseSelector = (state) => state.materialSubstitution;

export const getTree = createSelector(baseSelector, (state) => state.tree);

export const getNoticeMaterialId = createSelector(baseSelector, (state) => state.noticeMaterialId);

export const getOldMaterialId = createSelector(baseSelector, (state) => state.oldMaterialId);

export const getIsFetching = createSelector(baseSelector, (state) => state.isFetching);

const initialState = {
  noticeMaterialId: null,
  oldMaterialId: null,
  isFetching: false,
  tree: null,
};

export default function materialSubstitution(state = initialState, action) {
  switch (action.type) {
    case SET_TREE:
      return {
        ...state,
        oldMaterialId: null,
        tree: action.payload,
      };

    case SET_NOTICE:
      return {
        ...state,
        noticeMaterialId: action.payload,
      };

    case FETCH_START:
      return {
        ...state,
        oldMaterialId: action.payload,
        isFetching: true,
        tree: null,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tree: action.payload,
      };

    case FETCH_FAIL:
      return {
        ...state,
        isFetching: false,
        tree: null,
      };

    default:
      return state;
  }
}
